export const BACKENDPOINT ="https://qtify-backend-labs.crio.do";